import axios from 'axios';
import prepareRequestOptions from '../utils/admin-apis.util';

export const getSearchListData = async () => {
  const options = prepareRequestOptions(
    `/admin/content/channels/search-list`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getListData = async (params = '', signal = null) => {
  const options = prepareRequestOptions(
    `/admin/content/channels/list${params}`,
    'GET',
    null,
    true,
    signal
  );

  const response = await axios(options);
  return response.data;
};

export const createNewData = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/content/channels/create',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const viewDataById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/content/channels/${id}/view`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const updateDataById = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/content/channels/${id}/update`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getChannelAssetData = async (id) => {
  const options = prepareRequestOptions(
    `/admin/channel/${id}/assets`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const updateChannelAssetData = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/channel/${id}/assets`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const generateRokuFeed = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/channel/${id}/generate-roku-feed`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const regenerateCache = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/channel/${id}/regenerate-cache`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const addVideosById = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/content/channels/${id}/add-video`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};
export const removeVideosById = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/content/channels/${id}/remove-video`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const deleteDataById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/content/channels/${id}/delete`,
    'DELETE',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const toggleMigratedStatus = async (payload) => {
  const options = prepareRequestOptions(
    `/admin/content/channels/migrated-status/toggle`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const updatePreviewWebChannel = async (payload) => {
  const options = prepareRequestOptions(
    `/admin/content/channels/preview-channel`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getPreviewWebChannel = async () => {
  const options = prepareRequestOptions(
    `/admin/content/channels/preview-channel`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const exportChannelVideosData = async (id) => {
  const options = prepareRequestOptions(
    `/admin/content/channel/${id}/videos/export`,
    'POST',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getChannelVideoScheduleList = async (
  id,
  params = '',
  signal = null
) => {
  const options = prepareRequestOptions(
    `/admin/channel/${id}/video-schedule/list${params}`,
    'GET',
    null,
    true,
    signal
  );

  const response = await axios(options);
  return response.data;
};

export const getChannelRulesetList = async () => {
  const options = prepareRequestOptions(
    `/admin/channel/ruleset/list`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const exportAllChannelsSchedule = async (params = '') => {
  const options = prepareRequestOptions(
    `/admin/content/channel/all-schedule-export${params}`,
    'POST',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const downloadAllChannelsSchedule = async (params = '') => {
  const options = prepareRequestOptions(
    `/admin/content/channel/download-all-schedule${params}`,
    'POST',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const incrementalRunAssignment = async (id) => {
  const options = prepareRequestOptions(
    `/admin/content/channel/${id}/ruleset/incremental/assignment`,
    'POST',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const incrementalRunSchedule = async (id) => {
  const options = prepareRequestOptions(
    `/admin/content/channel/${id}/ruleset/incremental/schedule`,
    'POST',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const incrementalRunHeroSchedule = async (id) => {
  const options = prepareRequestOptions(
    `/admin/content/channel/${id}/ruleset/incremental/hero-schedule`,
    'POST',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const restoreChannelAssignmentScheduling = async () => {
  const options = prepareRequestOptions(
    `/admin/content/channel/assignment/restore`,
    'POST',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const exportChannelVideosSkippedContentData = async (
  id,
  params = ''
) => {
  const options = prepareRequestOptions(
    `/admin/content/channel/${id}/videos/skipped-content/export${params}`,
    'POST',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const exportAllBlockedVideos = async () => {
  const options = prepareRequestOptions(
    `/admin/content/channel/get-blocked-videos`,
    'POST',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getBlackoutChannelsList = async (params = '', signal = null) => {
  const options = prepareRequestOptions(
    `/admin/content/channel/blackout/list${params}`,
    'GET',
    null,
    true,
    signal
  );

  const response = await axios(options);
  return response.data;
};
